export default {
  video: {
    title: '实时视频',
    viewSwitch: '视角切换：{view}',
  },
  views: {
    head: '头部视角',
    leftHand: '左手视角',
    rightHand: '右手视角',
  },
  info: {
    toggle: '机器人信息',
  },
  robotInfo: {
    title: '机器人信息',
    battery: '电量',
    batteryTemperature: '电池温度',
    voltage: '电压',
    position: '位置',
    positionXY: 'X: {x}，Y: {y}',
    noValue: '--',
    noValuePercent: '--%',
    postureStanding: '站立中',
    postureLying: '趴下',
    postureUnknown: '未知',
  },
  control: {
    moveSection: '移动控制',
    end: '结束',
    pause: '停止',
  },
  messages: {
    stopSuccess: '停止任务成功',
    endTaskSuccess: '结束任务成功',
    stopFailed: '巡检任务停止失败',
    noActiveTask: '暂无进行中的任务',
    pauseSuccess: '暂停成功',
    pauseFailed: '暂停任务失败',
    streamNotConfigured: '当前视角流地址未配置',
  },
}
